<page-header [action]="phActionTpl">
  <ng-template #phActionTpl></ng-template>
</page-header>
<full-content [fullscreen]="false">
  <nz-card>
    <st
      #st
      [data]="datalist"
      size="middle"
      [columns]="columns"
      [ps]="20"
      [scroll]="{ y: 'calc(100vh - 304px)' }"
    >
      <ng-template st-row="nameTpl" let-item let-index="index">
        <ng-container>
          <span
            style="cursor: pointer"
            (click)="createTplModal(tplTitle, tplContent, tplFooter, item.title)"
          >
            {{ item.title }}
          </span>
        </ng-container>
      </ng-template>
    </st>
    <ng-template #tplTitle>
      <span>{{ title }}</span>
    </ng-template>
    <ng-template #tplContent let-params>
      <p>{{ answer }}</p>
    </ng-template>
    <ng-template #tplFooter let-ref="modalRef">
      <button nz-button nzType="primary" (click)="ref.destroy()">OK</button>
    </ng-template>
  </nz-card>
</full-content>
